/*
 * @Author: Merlin
 * @Date: 2024-01-15 19:32:25
 * @LastEditors: Merlin
 * @LastEditTime: 2024-07-15 19:15:53
 * @Description: 
 */


const introduction = {
    sectionTitle: {
        en: 'Get riches in Corgi Pharaoh',
        cn: '在 Corgi Pharaoh 获得财富',
    },
    sectionSubtitle: {
        en: 'Play the New Original Slot!',
        cn: '玩新的内部老虎机！',
    },
    sectionText: {
        en: 'Experience the thrill of the new Original Slot with an exciting Bonus game. Enjoy high winnings, a multiplier feature, and a hot Egypt atmosphere. Spin the reels across 5 paylines and discover the secrets of the pharaohs.',
        cn: '通过令人兴奋的特奖游戏体验全新内部老虎机的刺激。享受巨额赢分、超高倍率与热烈的埃及氛围。你将会通过旋转这 5 条中奖线而找到法老的秘密。',
    },
    title2: {
        en: 'Experience unique Gameplay',
        cn: '体验独特的游戏玩法',
    },
    text2: {
        en: 'Discover the power of the ancient world - play Corgi Pharaoh and enjoy amazing features!',
        cn: '尽情探索古代世界的神秘力量，玩 Corgi Pharaoh 并享受充满惊喜的游戏功能',
    },
};


// ▼用于游戏 keno
export const oPharaohGame = {
    ...introduction,
    'BuyBonus': {
        en: 'Buy bonus', 
        cn: '购买特奖',
    },
    'BuyBonusPrice': {
        en: 'Buy Bonus price',
        cn: '购买特奖价格',
    },
    'Bet': {
        en: 'Bet', 
        cn: '押注',
    },
    'Stop': {
        en: 'Stop', 
        cn: '停止',
    },
    // ======================================= 
    'ruleDesc01': {
        en: 'All wins shown as a multiple of the active Coin Size', 
        cn: '赢分以当前钱包有效资产作为倍率基础',
    },
    'ruleText': {
        en: `Spin the reels and match the same patterns to win prizes, and trigger special symbols to enter the bonus game to win higher prizes.`,
        cn: `旋转转轴并匹配相同图案以赢取奖金，触发特殊符号可进入奖金游戏赢取更高奖励。`,
    },
};




